export default () => {
	const oldBrowserAlertMessage = 'It seems like you are using an old browser which is already deprecated. Please consider upgrading your browser to a newer one, for example to Google Chrome, Safari, Mozilla Firefox or Microsoft Edge.'
	const isIE = /*@cc_on!@*/false || !!document.documentMode;

	if (isIE) {
		alert(oldBrowserAlertMessage);
	}
};